export default __webpack_public_path__ + "static/media/Abee Research.3cac7d87.png";